import { ArrowRight } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative bg-[#F2EDE4] py-32 md:py-48 overflow-hidden border-t border-zinc-900"
    >
      {/* Subtle warm grain */}
      <div className="absolute inset-0 grain opacity-60" />
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 50% 60%, rgba(0,0,0,0.06), transparent 60%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="reveal flex items-center justify-center gap-3 mb-8">
          <span className="h-px w-10 bg-zinc-500" />
          <span className="text-xs tracking-[0.3em] uppercase text-zinc-600 font-bold">
            Invest In Yourself · Stop Overthinking · Start Building
          </span>
          <span className="h-px w-10 bg-zinc-500" />
        </div>

        <h2
          data-testid="final-cta-headline"
          className="reveal text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] tracking-tighter font-extrabold text-[#0A0A0A] leading-[0.98]"
        >
          You do not need <br />
          everything figured out <br />
          <span className="italic font-light text-zinc-700">to start.</span>
        </h2>

        <p className="reveal mt-10 max-w-2xl mx-auto text-base md:text-lg leading-relaxed text-zinc-700 font-medium">
          Most people stay stuck because they wait for certainty that never
          comes. Business rewards people who move, adapt and keep building.{" "}
          <span className="text-[#0A0A0A] font-semibold">
            The Builder Programme
          </span>{" "}
          exists to help ambitious people stop overthinking and start executing
          properly.
        </p>

        <div className="reveal mt-12">
          <a
            href="#apply"
            data-testid="final-cta-apply-btn"
            className="group inline-flex items-center gap-3 bg-[#0A0A0A] text-white font-bold text-sm tracking-[0.15em] uppercase px-8 py-5 hover:bg-black transition-colors duration-300"
          >
            Apply To The Builder Programme
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>

        <p className="reveal mt-6 text-xs tracking-[0.25em] uppercase text-zinc-500 font-bold">
          Application Only · Limited Cohort
        </p>
      </div>
    </section>
  );
};
